/* Carrousel « Comment l'activer » — defilement par etape. */
(function () {
  function init(section) {
    if (section.dataset.mpHowBound === 'true') return;
    section.dataset.mpHowBound = 'true';
    var track = section.querySelector('[data-mp-how-track]');
    var slides = section.querySelectorAll('[data-mp-how-slide]');
    var dots = section.querySelectorAll('[data-mp-how-dot]');
    var prev = section.querySelector('[data-mp-how-prev]');
    var next = section.querySelector('[data-mp-how-next]');
    if (!track || !slides.length) return;
    var index = 0;

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    function go(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      render();
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    for (var d = 0; d < dots.length; d++) {
      (function (n) { dots[n].addEventListener('click', function () { go(n); }); })(d);
    }

    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) go(index + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });

    render();
  }

  function boot() { document.querySelectorAll('[data-mp-how]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
